type SecretAccessKeyValidatorContext = {
  isAwsS3: boolean;
  isEditMode: boolean;
  accessKeyId: string;
  previousAccessKeyId: string;
};

export const validateBaseURI = (value: string) => {
  const trimmed = value.trim();

  if (!trimmed) {
    return "Base URI field is required.";
  }

  if (!trimmed.startsWith("s3://")) {
    return "Base URI must start with s3://";
  }

  return true;
};

export const getSecretAccessKeyValidator =
  ({ isAwsS3, isEditMode, accessKeyId, previousAccessKeyId }: SecretAccessKeyValidatorContext) =>
  (value: string) => {
    if (isAwsS3) {
      return true;
    }

    const trimmedAccessKeyId = accessKeyId.trim();

    // An empty access key ID means an anonymous, public-bucket read.
    if (!trimmedAccessKeyId) {
      return true;
    }

    const secret = value.trim();

    if (isEditMode) {
      const accessKeyChanged = trimmedAccessKeyId !== previousAccessKeyId;

      if (accessKeyChanged && !secret) {
        return "Provide a new secret access key when changing the access key ID.";
      }

      return true;
    }

    if (!secret) {
      return "Secret access key is required when an access key ID is set.";
    }

    return true;
  };
